import { RMWCProvider as DefaultRMWCProvider } from "@rmwc/provider";
import * as React from "react";

export const RMWCProvider: React.FC = props => (
  <DefaultRMWCProvider
    icon={{
      basename: "google-material-icons",
    }}
  >
    {props.children}
  </DefaultRMWCProvider>
);
